module.exports = __webpack_public_path__ + "static/img/Bachelor_010686.fa50ff9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010686.jpg
// module id = 212
// module chunks = 0